import { Component } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { MatterPropertyType } from '@models/matter';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './parcel-of-tied-land-overview.hooks';

@Component({
	selector: 'app-parcel-of-tied-land-overview',
	templateUrl: './parcel-of-tied-land-overview.component.html',
	animations: [openClose()],
	standalone: false,
})
export class ParcelOfTiedLandOverviewComponent {
	testHooks = TestHooks;
	@ViewSelectSnapshot(SelectedMatter.propertyType)
	propertyType: MatterPropertyType;

	public showForm = false;

	public ICON = ICON;
	constructor() {}

	showFormToggle() {
		this.showForm = !this.showForm;
	}

	onFormCancel() {
		this.showFormToggle();
	}

	onFormSubmit() {
		this.showFormToggle();
	}
}
